export const DEFAULT_ROUTE = '/';
export const LOGIN_ROUTE = '/login';
export const MYCARS_ROUTE = '/mycars';
export const RESERVATIONS_ROUTE = '/reservations';
export const REPORT_ROUTE = '/report';
export const LOGOUT_ROUTE = '/logout';
export const BOOKING_DONE_ROUTE = '/your-reservation';
export const SHARE_PLACE_ROUTE = '/share-place/:spotId';
export const FREE_PLACES_ROUTE = '/free-places';
export const SIGN_POST_ROUTE = '/sign-post';
export const BOOKING_FORM = '/booking';
export const PERMANENT_PLACES_ROUTE = '/permanent-places';

export const ADMIN_ROUTE = '/administration';
export const ADMIN_LOTS_ROUTE = `${ADMIN_ROUTE}/lots`;
export const ADMIN_GENERAL_ROUTE = `${ADMIN_ROUTE}/settings`;
export const ADMIN_RESERVATIONS_ROUTE = `${ADMIN_ROUTE}/reservations`;
export const USER_ROUTE = `${ADMIN_ROUTE}/users`;

export const SHARE_PLACE_DONE_ROUTE = '/thank-you';
export const SHARE_CAR_ROUTE = '/share-car/:carId';
